import client from '.';

export const getListProjectAPI = () => {
  return client.get('/Projects').then(res => res.data);
};

export const getDashboardProjectsAPI = () => {
  return client.get(`/Projects?time=${Date.now()}`).then(res => res.data);
};

export const selectProjectAPI = projectId => {
  return client.post(`/Projects/${projectId}`).then(res => res.data);
};

export const getProjectsAPI = params => {
  return client.post(`/Projects/get-projects`, params).then(res => res.data);
};

export const getDetailProjectAPI = projectId => {
  return client.post(`/Projects/${projectId}`).then(res => res.data);
};

export const createProjectAPI = params => {
  return client.post(`/Projects/create-project`, params).then(res => res.data);
};

export const editProjectAPI = params => {
  return client.post(`/Projects/update-project`, params).then(res => res.data);
};

export const getProjectDetailRolesAPI = params => {
  return client.post(`/Projects/get-project-detail-roles`, params).then(res => res.data);
};

export const updateProjectRoleAPI = params => {
  return client.post(`/Projects/update-project-role`, params).then(res => res.data);
};

export const getProjectDetailUsersAPI = projectId => {
  return client.get(`/Projects/get-project-detail-users?projectId=${projectId}`).then(res => res.data);
};

export const deactivateProjectAPI = projectId => {
  return client.post(`/Projects/deactivate-project?projectId=${projectId}`).then(res => res.data);
};

export const activateProjectAPI = projectId => {
  return client.post(`/Projects/activate-project?projectId=${projectId}`).then(res => res.data);
};

export const getProjectTypesAPI = () => {
  return client.get(`/Projects/get-project-types`).then(res => res.data);
};

export const getProjectWithAdminfunctionPermissionAPI = () => {
  return client.get(`/Projects/projects-with-adminfunction-permission`).then(res => res.data);
};

export const getEnvironmentsAPI = params => {
  return client.post(`/Environment/get-environments`, params).then(res => res.data.data);
};

export const createEnvAPI = params => {
  return client.post(`/Environment/create-environment`, params).then(res => res.data);
};

export const updateEnvAPI = params => {
  return client.post(`/Environment/update-environment`, params).then(res => res.data);
};

export const deleteEnvAPI = (projectId, environmentId) => {
  return client
    .delete(`/Environment/delete-environment?projectId=${projectId}&environmentId=${environmentId}`)
    .then(res => res.data);
};
